import React, {
    Fragment,
    useState,
    useEffect,
    forwardRef,
    useImperativeHandle
} from 'react';
import { TagBox } from 'devextreme-react/tag-box';
import sessions from '../../../sessions';
import serviceType from '../../../utils/service-type';
import { LoadPanel } from 'devextreme-react/load-panel';
import { useHistory } from 'react-router-dom';
import package_ from '../../../utils/package';
import contentType from '../../../utils/custome-intl';
import weightMetrics from '../../../utils/weight-metrics';
import sizeMetrics from '../../../utils/package-size';
import DataSource from 'devextreme/data/data_source';
import orderApi from '../../../api/order';
import addressApi from '../../../api/address';
import shipmentApi from '../../../api/shipment';
import paymentApi from '../../../api/payment';
import ViewSDKClient from '../../../components/adobe-dc/ViewSDKClient';
import Form, {Item, RequiredRule, EmptyItem, Label} from 'devextreme-react/form';
import notify from 'devextreme/ui/notify';
import { confirm } from 'devextreme/ui/dialog';
import 'whatwg-fetch';
import './multiple-label.scss';

const MultipleLabel = forwardRef(({data}, ref) => {
    const userId = sessions.getSession("user")?.id;
    const auth = sessions.getSession("user")?.accessToken;
    const role = sessions.getSession("user")?.roles[0];
    const [addressData, setAddressData] = useState();
    const [orderNo, setOrderNo] =  useState([]);
    const [orderIds, setOrderIds] =  useState([]);
    const [shipmentData, setShipmentData] = useState([]);
    const [isUSA, setIsUSA] = useState(true);
    const [labelPrinted, setLabelPrinted] = useState();
    const [isloadPanelVisible, setIsloadPanelVisible] = useState(false);
    const history = useHistory();
    const [now,setNow] = useState();

    useEffect(() => {
        var orderNo = [];
        var orderIds = [];
        (async()=>{
            if (data?.length > 0) {
                var totalCost = 0;
                data.map(item => {
                    orderNo.push(item.orderNo);
                    orderIds.push(item._id);
                    totalCost+=parseFloat(item?.cost);
                    if(item?.labelPrinted)
                        setLabelPrinted(true);
                    if(item.country !== 'US')
                        setIsUSA(false);
                }); 
                setNow(new Date());
                setOrderNo(orderNo);
                setOrderIds(orderIds);
                setShipmentData({
                    "batchNo":data[0]?.batchNo,
                    "serviceType":data[0]?.serviceType,
                    "shipFromId":data[0]?.shipFrom,
                    "shipDate":data[0]?.shipDate,
                    "package":data[0]?.package,
                    "weight_units":data[0]?.weight_units?data[0]?.weight_units:'lb',
                    "weight_value":data[0]?.weight_value,
                    "size_units":data[0]?.size_units?data[0]?.size_units:'in',
                    "size_length":data[0]?.size_length,
                    "size_width":data[0]?.size_width,
                    "size_height":data[0]?.size_height,
                    "contentType":data[0]?.contentType,
                    "totalCost":totalCost?totalCost:0
                })
                await addressApi.getAddressByUserId(userId,auth).then(result=>{
                    setAddressData(result.data.data)
                }).catch(err=>{
                    console.log(err);
                })
            }
        })()
    }, [data])

    const saveOnClick = (e) => {
        const res = e.validationGroup.validate(); 
        onSubmit(e);
    }

    const shipsFromDataSource = new DataSource({
        store: {
            data: addressData,
            type: 'array',
            key: '_id'
        }
    });

    const PackageDataSource = new DataSource({
        store: {
            data: package_,
            type: 'array',
            key: 'ID'
        },
    });

    const contentTypeDataSource = new DataSource({
        store: {
            data: contentType,
            type: 'array',
            key: 'id'
        }
    });

    const WeightDataSource = new DataSource({
        store: {
            data: weightMetrics,
            type: 'array',
            key: 'ID'
        },
    });

    const SizeDataSource = new DataSource({
        store: {
            data: sizeMetrics,
            type: 'array',
            key: 'ID'
        },
    });

    const onMultiTagPreparing = (args) => {
        const selectedItemsLength = args.selectedItems.length;
        const totalCount = 1;
    
        if(selectedItemsLength < totalCount) {
          args.cancel = true;
        } else {
          args.text = `${selectedItemsLength} orders selected`;
        }
    }

    const onSubmit = async(e) => {
        e.event.preventDefault();
        var {serviceType} = shipmentData;
        var payload ={
            "data": data,
            "shipmentData": shipmentData
        };
        try{
            
            if(role === 'ROLE_ADMIN'){
                const paymentPayload = {
                    "cost":shipmentData.totalCost,
                    "notes":""
                }
                if(serviceType === 'Standard Shipment'){
                    await paymentApi.addCredit(data[0]?.userId,paymentPayload,auth);
                    setIsloadPanelVisible(true);
                    await shipmentApi.updateMultipleShipmentsByAdmin(payload,auth);
                    var pdfName =shipmentData?.batchNo;
                    await shipmentApi.fetchLabel(pdfName).then(res => {
                        const pdfBlob = new Blob([res.data], { type: 'application/pdf' })
                        var url = window.URL.createObjectURL(pdfBlob);
                        setIsloadPanelVisible(false);
                        const viewSDKClient = new ViewSDKClient();
                        viewSDKClient.ready().then(() => {
                        viewSDKClient.previewFile({embedMode: "LIGHT_BOX"},"",url,pdfName);
                        });
                    }).catch(err=>{
                        console.log(err);
                        setIsloadPanelVisible(false);
                    });
                }else{
                    if(labelPrinted){
                        let result = confirm("Are you sure want to print the label again?", "Confirm changes");
                        result.then(async(dialogResult) => {
                            if(dialogResult){
                                await paymentApi.addCredit(data[0]?.userId,paymentPayload,auth);
                                setIsloadPanelVisible(true); 
                                await shipmentApi.generateMultipleLabel(data[0]?.userId,payload,auth).then(async(result)=>{
                                    var pdfName = result.data.data;
                                    await shipmentApi.fetchLabel(pdfName).then(res => {
                                        console.log(res.data);
                                        const pdfBlob = new Blob([res.data], { type: 'application/pdf' })
                                        var url = window.URL.createObjectURL(pdfBlob);
                                        setIsloadPanelVisible(false);
                                        const viewSDKClient = new ViewSDKClient();
                                        viewSDKClient.ready().then(() => {
                                        viewSDKClient.previewFile({embedMode: "LIGHT_BOX"},"",url,pdfName);
                                        });
                                    });
                                }).catch(err=>{
                                    console.log(err);
                                    setIsloadPanelVisible(false);
                                });
                            }
                        })
                    }else{
                        await paymentApi.addCredit(data[0]?.userId,paymentPayload,auth);
                        setIsloadPanelVisible(true); 
                        await shipmentApi.generateMultipleLabel(data[0]?.userId,payload,auth).then(async(result)=>{
                            var pdfName = result.data.data;
                            await shipmentApi.fetchLabel(pdfName).then(res => {
                                console.log(res.data);
                                const pdfBlob = new Blob([res.data], { type: 'application/pdf' })
                                var url = window.URL.createObjectURL(pdfBlob);
                                setIsloadPanelVisible(false);
                                const viewSDKClient = new ViewSDKClient();
                                viewSDKClient.ready().then(() => {
                                viewSDKClient.previewFile({embedMode: "LIGHT_BOX"},"",url,pdfName);
                                });
                            });
                        }).catch(err=>{
                            console.log(err);
                            setIsloadPanelVisible(false);
                        });
                    }
                   
                }
            }else{
                setIsloadPanelVisible(true);
                var isnotUS = false;
                var countryOutofServiceMsg ="";
                if(serviceType === 'Standard Shipment'){
                    const result = await shipmentApi.getAvailableCountryForService(data,auth);
                    if(result.data.data){
                        console.log(result.data.data)
                        countryOutofServiceMsg = result.data.data;
                    }
                }else{
                    for (var i = 0, l = data.length; i < l; i++) {
                        if(data[i].country!=='US'){
                            isnotUS = true;
                        } 
                    }
                }
            
                await paymentApi.getUserLatestBalance(userId,auth).then(async(result)=>{
                    const balance =  result.data.data.balance;
                    if(balance > 50){
                        if(serviceType === 'Standard Shipment'){
                            if(countryOutofServiceMsg){
                                setIsloadPanelVisible(false);
                                notify(countryOutofServiceMsg, "error", 500);
                            }else{
                                await shipmentApi.generateMultipleLabelAndPackingSlip(userId,payload,auth).then(async(result)=>{
                                    var pdfName = result.data.data;
                                    await orderApi.fetchPackingSlips(pdfName).then(res => {
                                        setIsloadPanelVisible(false);
                                        e.validationGroup.reset();
                                        history.replace(`/orders/awaiting-shipment`);
                                        const pdfBlob = new Blob([res.data], { type: 'application/pdf' })
                                        var url = window.URL.createObjectURL(pdfBlob);
                                        const viewSDKClient = new ViewSDKClient();
                                        viewSDKClient.ready().then(() => {
                                            viewSDKClient.previewFile({embedMode: "LIGHT_BOX"},"",url,pdfName);
                                        });
                                    }).catch(err=>{
                                        setIsloadPanelVisible(false);
                                        notify("error", "error", 500);
                                    })
                                }).catch(err=>{
                                    setIsloadPanelVisible(false);
                                    notify("error", "error", 500);
                                });
                            }
                        }else{
                            if(!isnotUS){
                                await orderApi.generateMultiplePackingSlips(userId,payload,auth).then(async(result)=>{
                                    var pdfName = result.data.data;
                                    await orderApi.fetchPackingSlips(pdfName).then(res => {
                                        setIsloadPanelVisible(false);
                                        e.validationGroup.reset();
                                        history.replace(`/orders/awaiting-shipment`);
                                        const pdfBlob = new Blob([res.data], { type: 'application/pdf' })
                                        var url = window.URL.createObjectURL(pdfBlob);
                                        const viewSDKClient = new ViewSDKClient();
                                        viewSDKClient.ready().then(() => {
                                            viewSDKClient.previewFile({embedMode: "LIGHT_BOX"},"",url,pdfName);
                                        });
                                    });
                                }).catch(err=>{
                                    if(err.message.includes("403")){
                                        notify("USA Eco only available for US", "error", 500);
                                        setIsloadPanelVisible(false);
                                    }
                                   
                                });
                            }else{
                                setIsloadPanelVisible(false);
                                notify("USA Eco only available for US", "error", 500);
                            }
                        }
                    }   
                    else{
                        setIsloadPanelVisible(false);
                        notify("Your balance is not enough to print the label", "success", 500);
                    }
                });
            }
        }catch(err){
            console.log(err)
            setIsloadPanelVisible(false);
        }
    }

    useImperativeHandle(ref, (e) => ({saveOnClick}));

    return (
        <Fragment>
         <div className={'multiple-label'}>
            <div className={'flex'}>
                <div className="dx-field">
                    <div className="dx-field-item-label-text">Order</div>
                    <div className="dx-field-value">
                        <TagBox 
                         items={orderNo}
                         value={orderNo} 
                         defaultValue={orderNo}
                         disabled={false}
                         stylingMode={'filled'}
                         width={'45vw'}
                         maxDisplayedTags={1}
                         onMultiTagPreparing={onMultiTagPreparing} 
                         />
                    </div>
                </div>
            </div>
            <br/>
            <form id="generate-multiple-label" onSubmit={saveOnClick}>
                <Form formData={shipmentData} labelLocation={'left'} validationGroup='group'>
                <Item itemType="group" caption="Shipment Information" colCount={8}>
                    <Item dataField={'orderIds'} visible={false} editorOptions={{value:orderIds,defaultValue:orderIds}}/> 
                    <Item
                        editorType={'dxDateBox'}
                        dataField="shipDate"
                        colSpan={4}
                        editorOptions={{
                            stylingMode: 'filled',
                            useMaskBehavior: true,
                            type: "date",
                            displayFormat: "shortdate",
                            min:now,
                            height: '40px',
                            placeholder: '',
                    }}>
                        <Label text={'Shipment Date'}/>
                        <RequiredRule message="shipping date is required"/>
                    </Item>
                    <Item
                        editorType={'dxSelectBox'}
                        dataField="shipFromId"
                        colSpan={4}
                        editorOptions={{
                        stylingMode: 'filled',
                        dataSource: shipsFromDataSource,
                        searchEnabled: true,
                        displayExpr: 'name',
                        valueExpr: '_id',
                        height: '40px',
                        placeholder: '',
                    }}>
                        <Label text={"Ship From"}/>
                        <RequiredRule message="ship from is required"/>
                    </Item>
                    <Item
                        editorType={'dxSelectBox'}
                        dataField="serviceType"
                        colSpan={4}
                        editorOptions={{
                        stylingMode: 'filled',
                        dataSource: serviceType,
                        searchEnabled: true,
                        displayExpr: 'name',
                        valueExpr: 'name',
                        height: '40px',
                        placeholder: ''
                    }}>
                        <RequiredRule message="service type is required"/>
                    </Item>
                    <Item
                        colSpan={4}
                        editorType={'dxSelectBox'}
                        dataField="package"
                        editorOptions={{
                        stylingMode: 'filled',
                        dataSource: PackageDataSource,
                        searchEnabled: true,
                        displayExpr: 'name',
                        valueExpr: 'name',
                        height: '40px',
                        placeholder: '',
                    }}/>
                    <Item
                        editorType={'dxSelectBox'}
                        dataField="weight_units"
                        cssClass={'p-0'}
                        editorOptions={{
                        dataSource: WeightDataSource,
                        stylingMode:'filled',
                        searchEnabled: true,
                        displayExpr: 'name',
                        valueExpr: 'name',
                        height: '40px',
                        width: '70px',
                        marginRight: '4rem',
                        placeholder: 'Select weight metrics'
                    }}>
                         <RequiredRule message="weight metrics is required"/>
                         <Label text={'Weight & Size'}/>
                    </Item>
                    <EmptyItem/>
                    <Item 
                    editorType={'dxNumberBox'} 
                    dataField={'weight_value'} 
                    editorOptions={{
                        placeholder:'W',
                        stylingMode: 'filled',
                        height: '40px',
                        width: '50px',
                        invalidValueMessage:"Value must be a number",
                        min:0
                    }}>
                        <RequiredRule message=" weight value is required"/>
                        <Label text=" "/>
                    </Item>
                    <EmptyItem editorOptions={{width:0}}/>
                     <Item
                        editorType={'dxSelectBox'}
                        dataField="size_units"
                        cssClass={'p-0'}
                        editorOptions={{
                        dataSource: SizeDataSource,
                        stylingMode: 'filled',
                        height: '40px',
                        width: '70px',
                        margin: '20px',
                        searchEnabled: true,
                        displayExpr: 'name',
                        valueExpr: 'name',
                        placeholder: '',
                        value:'in'
                    }}>
                         <Label text={' '} location={'right'}/>
                         <RequiredRule message="size units is required"/>
                    </Item>
                    <Item 
                    editorType={'dxNumberBox'} 
                    dataField={'size_length'} 
                    editorOptions={{
                        placeholder:'L',
                        stylingMode: 'filled',
                        height: '40px',
                        width: '40px',

                    }}>
                        <RequiredRule message="length is required"/>
                        <Label text="L" location={'right'}/>
                    </Item>
                    <Item 
                    editorType={'dxNumberBox'} 
                    dataField={'size_width'} 
                    editorOptions={{
                        placeholder:'W',
                        stylingMode: 'filled',
                        height: '40px',
                        width: '40px',
                        defaultValue:0
                    }}>
                        <RequiredRule message="width is required"/>
                        <Label text="W" location={'right'}/>
                    </Item>
                    <Item 
                        editorType={'dxNumberBox'} 
                        dataField={'size_height'} 
                        editorOptions={{
                            placeholder:'H',
                            stylingMode: 'filled',
                            height: '40px',
                            width: '40px',
                            defaultValue:0
                        }}>
                        <RequiredRule message="height is required"/>
                        <Label text="H" location={'right'}/>
                    </Item>
                    <Item 
                        id={'content-type'}
                        editorType={'dxSelectBox'}
                        isRequired={true}
                        dataField="contentType"
                        visible= {!isUSA}
                        colSpan={4}
                        editorOptions={{
                        stylingMode: 'filled',
                        height: '40px',
                        dataSource: contentTypeDataSource,
                        searchEnabled: true,
                        displayExpr: 'name',
                        valueExpr: 'name',
                        placeholder: ''
                    }}>
                        <RequiredRule message="content type is required"/>
                        <Label text={'Content Type'}/>
                    </Item>
                    <Item
                        editorType={'dxDateBox'}
                        dataField="warehouseReceiveTimes"
                        colSpan={4}
                        visible={role === 'ROLE_ADMIN'?true:false} 
                        editorOptions={{
                            stylingMode: 'filled',
                            height: '40px',
                            useMaskBehavior: true,
                            type: "datetime",
                            displayFormat: "shortdate",
                            value:now,
                            min:now,
                            placeholder: '',
                    }}>
                        <Label text={'Receive Time'}/>
                        <RequiredRule message="shipping date is required"/>
                    </Item>
                    <Item 
                        editorType={'dxTextBox'} 
                        dataField={'notes'} 
                        colSpan={4}
                        visible={role === 'ROLE_ADMIN'?true:false} 
                        editorOptions={{
                            stylingMode: 'filled'
                    }}>
                    </Item>
                    <Item 
                    editorType={'dxNumberBox'} 
                    dataField={'totalCost'} 
                    colSpan={8}
                    disabled={role === 'ROLE_ADMIN'?false:true} 
                    helpText={'Cost will be determine after we verified the weight and size'}
                    editorOptions={{
                        stylingMode: 'filled',
                        height: '40px',
                        width: '60px',
                        defaultValue:0,
                        min:0,
                        format: "$ #,##0.##;$ #,##0.##)"
                    }}>
                    </Item>
                </Item>
                </Form>
                <LoadPanel
                position={'#stripes-form'}
                shadingColor="rgba(0, 0, 0, 0.2)"
                onHiding={!isloadPanelVisible}
                visible={isloadPanelVisible}
                showIndicator={true}
                shading={true}
                showPane={true}
                message={'loading..'}
                closeOnOutsideClick={false}/>
            </form>
         </div>
        </Fragment>
    )
})
export default MultipleLabel;